export default {
    dataFeeds(state) {
        return state.dataFeeds;
    },
};
